import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../styles/footer.css";

function Footer() {
  return (
    <footer className="main-footer">
      <div
        className="elementor-shape elementor-shape-top"
        data-negative="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          style={{ float: "right", width: "100%", height: "40px" }}
          preserveAspectRatio="none"
        >
          <path
            className="elementor-shape-fill"
            d="M0,6V0h1000v100L0,6z"
          ></path>
        </svg>{" "}
      </div>
      <div className="container footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <a>
            <img src="/logo.png" alt="logoF" title="logo" />
          </a>
          <p>Custom commercial spaces, ready in 100 days. Guaranteed by:</p>

          <img src="/Fert-PNG.png" alt="fert" title="logo" />
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/#about">About</a>
            </li>
            <li>
              <a href="/properties">Properties</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
            <li>
              <a href="/Collaborate">Collaborate</a>
            </li>
            <li>
              <a href="/blogs">Blogs</a>
            </li>
          </ul>
        </div>

        {/* Legal Links */}
        <div className="footer-legal">
          <h3>Legal</h3>
          <ul>
            <li>
              <a href="/terms">Terms & Conditions</a>
            </li>
            <li>
              <a href="/privacy">Privacy Policy</a>
            </li>
            <li>
              <a href="/Faqs">Faqs</a>
            </li>
            <li>
              <a href="/video">Video</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h3>Contact</h3>
          <ul>
            <li>
              <FaEnvelope />{" "}
              <a href="mailto:info@e-qera.com">info@e-qera.com</a>
            </li>
            <li>
              <FaPhone /> <a href="tel:+38346192921">+383 46 192 921</a>
            </li>
            <li>
              <FaMapMarkerAlt />{" "}
              <a
                href="https://maps.google.com?q=Pristina+Kosovo"
                target="_blank"
                rel="noreferrer"
              >
                Pristina, Kosovo
              </a>
            </li>
          </ul>
          <div className="footer-socials">
            <a href="#">
              <FaLinkedinIn />
            </a>
            <a href="#">
              <FaFacebookF />
            </a>
          </div>
        </div>
      </div>
      {/* Bottom Line */}
      <div className="footer-bottom">
        <p>
          © 2025 E-Qera. All Rights Reserved. Built for Visionaries. Powered by{" "}
          <a
            href="https://www.shigjeta.com"
            className="shigjeta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shigjeta.
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
